<template>
  <div>
    <search-table
      ref="searchTable"
      :columnMove="false"
      :columns="syncTableProperties"
      :data="openTableData"
      :need-pagination="false"
      :needAllColumnSummary="true"
      :showSummary="true"
      :tableRowKey="'id'"
      @getTableData="getTableData"
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';

export default {
  components: { SearchTable },
  props: ['tableData'],
  name: 'Comp',
  data() {
    return {
      syncTableProperties: [
        { label: '员工姓名', prop: 'stff_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { label: '所属打样间', prop: 'dept_name', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '排版款数', prop: 'numberOfLayoutStyles', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '排版片数', prop: 'numberOfTypesettingPieces', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '估价款数', prop: 'estimatedAmount', itemType: 'input', input: false, sortable: true, widthAuto: true }
      ]
    };
  },
  computed: {
    openTableData() {
      return this.tableData;
    }
  },
  methods: {
    getTableData() {
      setTimeout(() => {
        this.$refs.searchTable.$refs.multiTable.doLayout();
      }, 0);
      this.$emit('getTableData', this.$refs.searchTable.searchForm);
    }
  }
};
</script>

<style scoped></style>
